/**
 * MarkdownMessage Component
 * Renders markdown content with proper styling for chat messages
 */

import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Custom list item component
 * CSS handles paragraph unwrapping via `display: contents`
 */
function ListItem({ children, ...props }) {
  return <li className="md-list-item" {...props}>{children}</li>;
}

export default function MarkdownMessage({ content, className = '' }) {
  return (
    <div className={`markdown-content ${className}`}>
      <ReactMarkdown
        components={{
          // Override default elements for better chat styling
          p: ({ children }) => <p className="md-paragraph">{children}</p>,
          ul: ({ children }) => <ul className="md-list">{children}</ul>,
          ol: ({ children }) => <ol className="md-list md-list-ordered">{children}</ol>,
          li: ListItem,
          strong: ({ children }) => <strong className="md-bold">{children}</strong>,
          em: ({ children }) => <em className="md-italic">{children}</em>,
          code: ({ inline, children }) =>
            inline ? (
              <code className="md-code-inline">{children}</code>
            ) : (
              <pre className="md-code-block"><code>{children}</code></pre>
            ),
          h1: ({ children }) => <h4 className="md-heading">{children}</h4>,
          h2: ({ children }) => <h4 className="md-heading">{children}</h4>,
          h3: ({ children }) => <h5 className="md-heading">{children}</h5>,
          h4: ({ children }) => <h5 className="md-heading">{children}</h5>,
          h5: ({ children }) => <h6 className="md-heading">{children}</h6>,
          h6: ({ children }) => <h6 className="md-heading">{children}</h6>,
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" className="md-link">
              {children}
            </a>
          ),
          blockquote: ({ children }) => (
            <blockquote className="md-blockquote">{children}</blockquote>
          ),
          hr: () => <hr className="md-hr" />,
        }}
      >
        {content || ''}
      </ReactMarkdown>
    </div>
  );
}
